import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import { seoMeta, canonicalLink } from "@/lib/content-defaults";
import { Route as rootRoute } from "./__root";

// Sección discreta (solo enlace en el pie). Si la sección está apagada o sin artículos publicados (CP Admin → Artículos),
// la página muestra «no encontrado» con noindex, igual que cualquier URL inexistente.
export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "/articulos",
  head: () => ({
    meta: seoMeta({
      title: "Artículos de Calistenia — Calistenia Progresiva",
      description: "Guías de calistenia escritas por el equipo de Calistenia Progresiva: cómo empezar, cómo progresar y cómo entrenar con buena técnica.",
      path: "/articulos",
    }),
    links: [canonicalLink("/articulos")],
  }),
  component: lazyRouteComponent(() => import("./articulos-page"), "ArticulosPage"),
});
